import { useState } from 'react';
import Button from '../../../../components/button/Button';
import { NoAccountIcon } from '../../../../components/icons/NoAccountIcon';
import ConnectBankModal from '../ConnectBank';
import { Spin } from 'antd';
import { Loading3QuartersOutlined } from '@ant-design/icons';
import { useUserProfile } from '../../../../customhooks/useUserProfile';
import { hasPermission } from '../../../../components/dashboard/dashboardpage/utils';

const NoConnectionSetup = () => {
    const [openConnectModal, setOpenConnectModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { permissions } = useUserProfile();

    const handleOpenWithDelay = () => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
            setOpenConnectModal(true);
        }, 2000);
    };

    return (
        <>
            <>
                <h1 className='px-4 py-[20px] lg:px-0 lg:py-0 text-[20px] font-medium leading-[30px] text-ebony'>
                    Treasury
                </h1>

                {isLoading && (
                    <div className='w-full flex justify-center items-center lg:h-[80vh] h-[80dvh] bg-white lg:bg-transparent flex-col gap-6'>
                        <Spin
                            size='large'
                            tip='Loading widget...'
                            spinning={isLoading}
                            indicator={
                                <Loading3QuartersOutlined
                                    style={{ fontSize: 80 }}
                                    spin
                                />
                            }
                        />
                        <span className='text-[20px] font-medium'>
                            Loading widget...
                        </span>
                    </div>
                )}
                {!isLoading && (
                    <div className='w-full flex justify-center items-center lg:h-[80vh] h-[80dvh] bg-white lg:bg-transparent flex-col gap-2'>
                        <NoAccountIcon />
                        <h3 className='text-[18px] font-semibold text-center'>
                            No accounts connected
                        </h3>
                        <p className='lg:w-[25%] text-center text-midnightHaze text-[14px]'>
                            You will need to connect your account to begin to
                            use Treasury management. Use the button below to get
                            started.
                        </p>
                        {permissions &&
                            hasPermission({
                                userPermissions: permissions,
                                module: 'treasuryManagement',
                                permissionList: ['link'],
                                feature: 'treasuryManagement'
                            }) && (
                                <Button
                                    text='Add bank account'
                                    className='mt-3'
                                    size='sm'
                                    onClick={handleOpenWithDelay}
                                />
                            )}
                        <ConnectBankModal
                            open={openConnectModal}
                            onClose={() => setOpenConnectModal(false)}
                        />
                    </div>
                )}
            </>
        </>
    );
};

export default NoConnectionSetup;
